import React from 'react'
import { IconButton } from '@chakra-ui/react'

export default (props) => {
  return <IconButton {...props} />
}
